const ELEMENT_TYPE_TO_EC_TYPE = {
    TEXT_INPUT: 'ec__text',
    DATE_INPUT: 'ec__date',
    CHOICE: 'ec__text_choice',
};
/**
 * Projects the editor's ConsentElement[] and ConsentRole[] into the three MOM-facing
 * arrays that Cortex expects on ec__document_template:
 *   - ec__requested_signatures  (SIGNATURE and INITIALS elements)
 *   - ec__requested_data        (TEXT_INPUT, DATE_INPUT, CHOICE elements)
 *   - ec__signer_roles          (document-level role definitions)
 *
 * Position/page fields are intentionally omitted — they are only needed for the
 * PDF overlay editor and are not part of the Cortex signing workflow.
 *
 * `ec__key` is used as the fallback for any element whose `ec__title` is
 * empty, since Cortex requires titles to be unique within each array.
 */
export function projectDocumentToMomFields(elements, roles) {
    const ec__requested_signatures = [];
    const ec__requested_data = [];
    for (const el of elements) {
        const c = el.config;
        if (el.type === 'SIGNATURE' || el.type === 'INITIALS') {
            ec__requested_signatures.push({
                ec__key: c.ec__key,
                ec__signer_role: c.ec__signer_role ?? '',
                ec__title: c.ec__title || c.ec__key,
                ec__description: c.ec__description ?? '',
                ec__label: c.ec__label ?? '',
                ec__optional: c.ec__optional ?? false,
                ec__initials: el.type === 'INITIALS',
                ec__order: c.ec__order ?? 0,
                ec__custom_data: c.ec__custom_data ?? [],
            });
        }
        else {
            ec__requested_data.push({
                ec__key: c.ec__key,
                ec__signer_role: c.ec__signer_role ?? '',
                ec__title: c.ec__title || c.ec__key,
                ec__description: c.ec__description ?? '',
                ec__optional: c.ec__optional ?? false,
                ec__type: ELEMENT_TYPE_TO_EC_TYPE[el.type] ?? 'ec__text',
                ec__allow_multiple: c.ec__allow_multiple ?? false,
                ec__selection_options: c.ec__selection_options ?? '',
                ec__custom_data: c.ec__custom_data ?? [],
            });
        }
    }
    const ec__signer_roles = roles.map((r, i) => ({
        ec__key: r.id,
        ec__role: r.role,
        ec__signer_type: r.signerTypeId,
        ec__required: r.roleRequired,
        ec__order: i + 1,
    }));
    return { ec__requested_signatures, ec__requested_data, ec__signer_roles };
}
